import { TabBarVariant, TabTokens } from '.';
import { setAlpha } from '../../../design-tokens';

//  Note: This file was created to export the getTabTokens method without reexporting,
//  so that we can unit test this method.
export const getTabTokens: TabTokens = (dt: any, props: any) => {
  const primaryLight = props.variant === TabBarVariant.PrimaryLight;
  let focusToken = 'var(--focus-light-bg)';
  if (
    dt.enableNovaTokens &&
    primaryLight &&
    dt.themeVariant === 'light' &&
    !(props.alternate && props.selected)
  ) {
    focusToken = 'var(--focus-dark-bg)';
  }
  if (dt.enableNovaTokens) {
    const tabTokens = {
      bg:
        props.alternate && props.selected
          ? dt.c.colorUiLight
          : props.orientation === 'vertical' && props.selected
          ? dt.stateStandardNova.selected.bg
          : 'transparent',
      fg:
        props.orientation === 'vertical' && props.selected
          ? dt.stateStandardNova.selected.fg
          : dt.c.colorTextDefault,
      filter:
        props.orientation === 'vertical' && props.selected
          ? dt.stateStandardNova.selected.filter
          : dt.stateStandardNova.normal.filter,
      bd: 'transparent',
      'hover-bg': props.selected ? undefined : setAlpha(dt.c.colorNeutral, 0.1),
      'selected-indicator': props.standardSmall ? dt.c.colorNeutral : dt.c.colorTextDefault,
      'disabled-bg': 'transparent',
      'disabled-fg': dt.stateStandardNova.disabled.fg,
      'indicator-content': '""',
      'indicator-width': '2px',
      'editable-hover-bd': 'var(--tab-fg)',
      focus: focusToken,
      'selected-focus': dt.themeVariant === 'high-contrast' ? 'var(--focus-dark-bg)' : focusToken,
    };
    switch (dt.themeVariant) {
      case 'dark':
        return {
          ...tabTokens,
          'hover-bg': props.selected ? undefined : setAlpha(dt.c.colorNeutral, 0.25),
        };
      case 'high-contrast':
        return {
          ...tabTokens,
          bd: props.alternate ? dt.c.colorUiBorder : 'transparent',
          'hover-bg': props.selected ? undefined : setAlpha(dt.c.colorNeutral, 0.15),
        };
      default:
        if (primaryLight) {
          return {
            ...tabTokens,
            fg:
              props.alternate && props.selected
                ? dt.c.colorTextDefault
                : dt.statePrimaryNova.normal.fg,
            'hover-bg': props.selected ? undefined : setAlpha(dt.c.colorUiLight, 0.1),
            'selected-indicator': props.alternate ? dt.c.colorTextDefault : dt.c.colorUiLight,
            'disabled-bg': 'transparent',
            'disabled-fg': dt.statePrimaryNova.disabled.fg,
          };
        }
        return tabTokens;
    }
  }
  // Legacy Token Support
  switch (dt.baseReportThemeName) {
    case 'highcontrast2018':
    case 'highcontrast2017':
      return {
        bg:
          props.alternate && props.selected
            ? dt.c.black
            : props.orientation === 'vertical' && props.selected
            ? dt.stateStandard.selected.bg
            : 'transparent',
        fg: props.orientation === 'vertical' && props.selected ? dt.c.black : dt.c.white,
        filter: dt.stateStandard.normal.filter,
        bd: props.alternate ? dt.c.white : 'transparent',
        'selected-indicator': props.alternate ? dt.c.white : dt.c.hcStandardSelected,
        'disabled-bg': dt.stateStandard.disabled.bg,
        'disabled-fg': dt.stateStandard.disabled.fg,
        'indicator-content': props.alternate ? 'none' : '""',
        'indicator-width': '3px',
        focus: focusToken,
        'editable-hover-bd': 'var(--tab-fg)',
      };
  }
  switch (dt.themeVariant) {
    case 'dark':
      return {
        bg:
          props.alternate && props.selected
            ? dt.c.p_3
            : props.orientation === 'vertical' && props.selected
            ? dt.stateStandard.selected.bg
            : 'transparent',
        fg:
          props.orientation === 'vertical' && props.selected
            ? dt.stateStandard.selected.fg
            : dt.c.white,
        filter: dt.stateStandard.normal.filter,
        bd: 'transparent',
        'selected-indicator': dt.c.white,
        'disabled-bg': dt.stateStandard.disabled.bg,
        'disabled-fg': dt.stateStandard.disabled.fg,
        'indicator-content': '""',
        'indicator-width': '1px',
        focus: focusToken,
        'hover-bg': dt.c.white20,
        'editable-hover-bd': 'var(--tab-fg)',
      };
    case 'high-contrast':
      return {
        bg:
          props.alternate && props.selected
            ? dt.stateStandard.normal.bg
            : props.orientation === 'vertical' && props.selected
            ? dt.stateStandard.selected.bg
            : 'transparent',
        fg:
          props.orientation === 'vertical' && props.selected
            ? dt.stateStandard.selected.fg
            : dt.stateStandard.normal.fg,
        filter: dt.stateStandard.normal.filter,
        bd: dt.stateStandard.normal.bd,
        'selected-indicator': dt.stateStandard.normal.fg,
        'disabled-bg': dt.stateStandard.disabled.bg,
        'disabled-fg': dt.stateStandard.disabled.fg,
        'indicator-content': props.alternate ? 'none' : '""',
        'indicator-width': '3px',
        focus: focusToken,
        'hover-bg': dt.c.n_4,
        'editable-hover-bd': 'var(--tab-fg)',
      };
    default:
      return {
        bg:
          props.alternate && props.selected
            ? dt.c.white
            : props.orientation === 'vertical' && props.selected
            ? dt.stateStandard.selected.bg
            : 'transparent',
        fg:
          props.orientation === 'vertical' && props.selected
            ? dt.stateStandard.selected.fg
            : dt.c.n_3,
        filter: dt.stateStandard.normal.filter,
        'disabled-bg': dt.stateStandard.disabled.bg,
        'disabled-fg': dt.stateStandard.disabled.fg,
        bd: 'transparent',
        'selected-indicator': dt.c.n_3,
        'indicator-content': '""',
        'indicator-width': '1px',
        focus: focusToken,
        'hover-bg': setAlpha(dt.c.n1, 0.2),
        'editable-hover-bd': 'var(--tab-fg)',
      };
  }
};

// Spacing Tokens
export const getTabSpacingTokens = (dt: any) => ({
  'spacing-squish-s': dt.spacing.insetSquish.s.padding,
  'spacing-squish-m': dt.spacing.insetSquish.m.padding,
  'spacing-squish-l': dt.spacing.insetSquish.l.padding,
  'spacing-stretch-m': dt.spacing.insetStretch.m.padding,
  'spacing-xs': dt.spacing.core.xs,
  'spacing-s': dt.spacing.core.s,
  'spacing-m': dt.spacing.core.m,
  'spacing-l': dt.spacing.core.l,
  'spacing-xxs': dt.spacing.core.xxs,
});

// button look like
export const getIconButtonTokens = (dt: any) => ({
  'animation-duration': dt.animation.duration.standard,
  'animation-timing-function': dt.animation.timingFunction.standard,
  'icon-hover-fg': dt.enableNovaTokens ? dt.stateStandardNova.hover.fg : dt.stateStandard.hover.fg,
  'icon-hover-bg': dt.enableNovaTokens ? dt.stateStandardNova.hover.bg : dt.stateStandard.hover.bg,
  'icon-active-fg': dt.enableNovaTokens
    ? dt.stateStandardNova.active.fg
    : dt.stateStandard.active.fg,
  'icon-active-bg': dt.enableNovaTokens
    ? dt.stateStandardNova.active.bg
    : dt.stateStandard.active.bg,
  'icon-active-filter': dt.enableNovaTokens
    ? dt.stateStandardNova.active.filter
    : dt.stateStandard.active.filter,
  'icon-squish-s': dt.spacing.insetSquish.s.padding,
});
